var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnbS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C9.31394 0 12 2.68606 12 6C12 9.31394 9.31394 12 6 12C2.68606 12 0 9.31394 0 6C0 2.68606 2.68606 0 6 0Z",
    fill: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2975 5.99976L3.30183 7.5863L4.64991 8.37957V9.30841L2.51289 8.05505V5.53582L3.2975 5.99976ZM3.2975 4.41322V5.33774L2.51241 4.87332V3.9488L3.2975 3.48438L4.08644 3.9488L3.2975 4.41322ZM5.21289 3.9488L5.99798 3.48438L6.78692 3.9488L5.99798 4.41322L5.21289 3.9488Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8649 7.25745V6.32861L4.64999 6.79303V7.71755L3.8649 7.25745ZM5.21298 8.71226L5.99807 9.17668L6.78701 8.71226V9.63678L5.99807 10.1012L5.21298 9.63678V8.71226ZM7.91298 3.9488L8.69807 3.48438L9.48701 3.9488V4.87332L8.69807 5.33774V4.41322L7.91298 3.9488ZM8.69807 7.5863L8.7024 5.99976L9.48749 5.53534V8.05457L7.35048 9.30793V8.37909L8.69807 7.5863Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13504 7.25697L7.34995 7.71707V6.79255L8.13504 6.32812V7.25697Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13509 4.74219L8.13942 5.67103L6.78749 6.4643V8.05469L6.0024 8.51478L5.2173 8.05469V6.4643L3.86538 5.67103V4.74219L4.65384 4.27776L5.99759 5.07488L7.34951 4.27776L8.13846 4.74219H8.13509ZM3.8649 3.15613L5.99807 1.89844L8.13509 3.15613L7.34999 3.62055L5.99807 2.82344L4.64999 3.62055L3.8649 3.15613Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbS);
export default __webpack_public_path__ + "static/media/bnb-s.30a7586284a53d19ac6cdd450a6a5416.svg";
export { ForwardRef as ReactComponent };